const imageContentTypesByExtension = new Map([
  ['avif', 'image/avif'],
  ['bmp', 'image/bmp'],
  ['gif', 'image/gif'],
  ['heic', 'image/heic'],
  ['heif', 'image/heif'],
  ['jpeg', 'image/jpeg'],
  ['jpg', 'image/jpeg'],
  ['png', 'image/png'],
  ['webp', 'image/webp']
]);

function extensionFromName(name) {
  const value = String(name || '').toLowerCase();
  if (!value.includes('.')) return '';
  return value.split('.').pop() || '';
}

export function inferUploadContentType(file = {}) {
  const value = String(file.type || '').toLowerCase();
  const imageContentType = imageContentTypesByExtension.get(extensionFromName(file.name));
  if (value.startsWith('image/')) return value;
  if (imageContentType) return imageContentType;
  return value || 'application/octet-stream';
}

export function isImageUpload(file = {}) {
  const contentType = inferUploadContentType(file);
  return contentType.startsWith('image/') || imageContentTypesByExtension.has(extensionFromName(file.name));
}

export function isImageFileName(name) {
  return imageContentTypesByExtension.has(extensionFromName(name));
}
